'use strict';

var Kaylee = require('../../kaylee/Kaylee');
var log = require('../../log/Log').channel('KayleeService');

angular.module('inara').factory('KayleeService', KayleeService);

KayleeService.$inject = ['$q', '$rootScope'];

function KayleeService($q, $rootScope) {
    log.debug('initializing KayleeService');

    var initialized = false;
    var initializedPromises = []; 

    Kaylee.isInitialized = isInitialized;
    Kaylee.initializeDatabase = initializeDatabase;

    return Kaylee;

    function initializeDatabase(aliasOrConfig) {
        log.info('initializing firebase to ' + aliasOrConfig);
        Kaylee.initialize(aliasOrConfig);

        Kaylee.onUpdate(function() {
            $rootScope.$evalAsync();
        });

        initialized = true;
        resolveInitializedPromises();
    }

    function isInitialized() {
    	if (initialized) return $q.resolve();

    	var deferredPromise = {};
    	
    	deferredPromise.promise = $q(function(resolve, reject) {
    		deferredPromise.resolve = resolve;
    		deferredPromise.reject = reject;
    	});

    	initializedPromises.push(deferredPromise);

        return deferredPromise.promise;
    }

    function resolveInitializedPromises() {
    	for (var i = 0; i < initializedPromises.length; i++) {
    		initializedPromises[i].resolve();
    	}
    }
}

module.exports = KayleeService;
